import './index.css';
import * as React from 'react';
import 'react-jquery-plugin';
import {
  ScheduleComponent,
  ResourcesDirective,
  ResourceDirective,
  ViewsDirective,
  ViewDirective,
  Inject,
  Resize,
  TimelineMonth,
  ExcelExport,
  Day,
  DragAndDrop,
  TimelineViews,
  Week,
  WorkWeek,
  Month,
} from '@syncfusion/ej2-react-schedule';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import {
  CheckBoxSelection,
  DropDownListComponent,
  MultiSelectComponent,
} from '@syncfusion/ej2-react-dropdowns';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import { FcFilledFilter } from 'react-icons/fc';
import {
  IoIosArrowDown,
  IoIosArrowUp,
  IoIosSettings,
  IoMdBrush,
} from 'react-icons/io';
import { RiFilterFill, RiFilterOffFill } from 'react-icons/ri';
import Loading, { all_information, loadingShow } from '../App';
import Message from '../utils/Message/Message';
import {
  CheckBoxComponent,
  SwitchComponent,
} from '@syncfusion/ej2-react-buttons';
import { ThemeContext } from '../context/theme.context';
import defaultImage from '../assets/images/DefaultImage.png';
import moment from 'moment';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { GetSchedulerList } from '../services/TradePlanner/Scheduler/SchedulerService';
import { GetRosters } from '../services/Settings/Roster';
import { closest, isNullOrUndefined, removeClass } from '@syncfusion/ej2-base';
import { ContextMenuComponent } from '@syncfusion/ej2-react-navigations';
import {
  CreateNoteCapacity,
  DeleteCapacityWithIDRequest,
} from '../utils/CreateRequest';
import TPlannerNoteContent from '../utils/TradePlannerHelper';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import GlobalDialog from './GlobalDialog';
import { GoPencil } from 'react-icons/go';
import { BsSearch } from 'react-icons/bs';
import { getTrades } from '../services/tradeperson/trades';
import { Internationalization } from '@syncfusion/ej2-base';
import GenerateCapacity from '../utils/GenerateCapacity';
import { getAssignmentsDetails } from '../services/assignments/assignmentService';
import { connect } from 'react-redux';
import { RootState } from '../store';
import {
  changelargeMode,
  setDefaultTeams,
  setfilterConfirmation,
  setRefreshAssignmentComponent,
  setRefreshTeamComponent,
  setRefreshTradeComponent,
  setWeekStartDay,
} from '../redux/search.slice';
import {
  MultiSelectComponent as MultiSelectC,
  Inject as DDInject,
} from '@syncfusion/ej2-react-dropdowns';
import { GlobalMultiSelection } from './GlobalDropDown';
import { DropDownButtonComponent } from '@syncfusion/ej2-react-splitbuttons';
interface IProps {
  weekStartDay: number;
  defaultTeams: number[];
  setRefreshTeamComponent: (value: boolean) => void;
  setRefreshTradeComponent: (value: boolean) => void;
  setRefreshAssignmentComponent: (value: boolean) => void;
  filterConfirmation: boolean;
  server_gmt: number;
  defaultAssignments: number[];
  largeMode: boolean;
  storeTeam: string[];
  changelargeMode: () => void;
  setfilterConfirmation: (value: boolean) => void;
  setDefaultTeams: (value: []) => void;
  storeTrades: string[];
  storeAssign: string[];
  storeTradeAssignmentIds: string[];
}
interface IState {
  largeMode: boolean;
  queryParameter: Array<String>;
  startDate: Date | null;
  endDate: Date | null;
  allButton: boolean;
  currentDate: Date;
  schedulerAssignmentData: any;
  schedulerData: any;
  rosterData: any;
  current_query: string;
  shiftValues: Array<string>;
  isShiftHide: boolean;
  enableProfileImg: boolean;
  showDialog: boolean;
  showCapacityDialog: boolean;
}
class Scheduler extends React.Component<IProps, IState> {
  public static globalFilterData: any = [];
  static contextType = ThemeContext;
  public isMountForData = false;
  context!: React.ContextType<typeof ThemeContext>;
  private data: any;
  profilePopup: any;
  private objSce: ScheduleComponent;
  private checkFields: Object = {
    text: 'ELEMENT_ALIAS',
    value: 'ELEMENT_ALIAS',
  };
  public checkboxObj: CheckBoxComponent;
  public static loadingShow: boolean;
  // public static StoreTeam: any = [];
  // public static StoreTrades: any = [];
  // public static StoreAssign: any = [];
  public static StoreShift: any = [];
  public static AllFilterDAta: any = '';
  public static start_date: string;
  public static end_date: string;

  public mulObj: any;
  public initialSchedule: boolean = true;
  public LocalStoragDate = localStorage.getItem('TradePlannerDate');
  private DateRangeValue: Date[] = this.LocalStoragDate
    ? JSON.parse(this.LocalStoragDate).map(
        (dateString: string) => new Date(dateString)
      )
    : [
        new Date(moment().startOf('month').format('YYYY-MM-DD')),
        new Date(moment().endOf('month').format('YYYY-MM-DD')),
      ];
  private DateRangeValueForNote: Date[] = [
    new Date(),
    new Date(new Date().setDate(new Date().getDate() + 14)),
  ];
  public globalSchedularData: any[] = [];
  public defaultTeam: MultiSelectC = new MultiSelectC({});
  public defaultTeamList: any;
  public isNoteModeCapacitySwitchChecked: boolean = true;
  public NoteModeRangeDate: any;
  private current_query: string = '';
  private theQueryDate: string = '';
  private theQueryShift: string = '';
  private theQueryTeams: string = '';
  private theQueryTrades: string = '';
  private theQueryAssignmentsSpecial: string = '';
  private theQueryAssignments: string = '';
  private isPanelOpened: boolean = false;
  private selectedTarget: any;
  private contextMenuObj: ContextMenuComponent;
  private noteTextbox: TextBoxComponent = new TextBoxComponent({});
  private typeDropDown: DropDownListComponent = new DropDownListComponent({});
  private selectedName: string = '';
  private selected_note_color: string = '';
  private selected_note_id: number = 0;

  private viewIndex: number = 0;

  private contextMenuItems = [
    { text: 'New Note', iconCss: 'e-icons e-plus', id: 'Add' },
    { text: 'Create Capacity', iconCss: 'e-icons e-plus', id: 'Create' },
    {
      text: 'New Recurring Event',
      iconCss: 'e-icons e-repeat',
      id: 'AddRecurrence',
    },
    { text: 'Today', iconCss: 'e-icons e-timeline-today', id: 'Today' },
    { text: 'Edit Event', iconCss: 'e-icons e-edit', id: 'Save' },
    { text: 'Delete Event', iconCss: 'e-icons e-trash', id: 'Delete' },
    {
      text: 'Delete Event',
      id: 'DeleteRecurrenceEvent',
      iconCss: 'e-icons e-trash',
      items: [
        { text: 'Delete Occurrence', id: 'DeleteOccurrence' },
        { text: 'Delete Series', id: 'DeleteSeries' },
      ],
    },
    {
      text: 'Edit Event',
      id: 'EditRecurrenceEvent',
      iconCss: 'e-icons e-edit',
      items: [
        { text: 'Edit Occurrence', id: 'EditOccurrence' },
        { text: 'Edit Series', id: 'EditSeries' },
      ],
    },
  ];
  private activeCellsData: any;
  private thePerson: any;

  sortbyLastNameFunction = (args: any) => {
    const scheduleAssignmentData = this.state.schedulerAssignmentData as Array<{
      last_name: string;
    }>;

    if (!scheduleAssignmentData) {
      console.error('schedulerAssignmentData is undefined!');
      return;
    }
    const sortedData = scheduleAssignmentData.sort((a, b) => {
      const lastNameA = a.last_name?.toLowerCase() || '';
      const lastNameB = b.last_name?.toLowerCase() || '';
      return lastNameA.localeCompare(lastNameB);
    });

    this.setState({ schedulerAssignmentData: sortedData });
  };

  private sortCollapseItems = [
    { text: 'Name', id: 'alphabet' },
    { text: 'Surname', id: 'surname' },
  ];
  private sortDropDown() {
    return (
      <DropDownButtonComponent
        items={this.sortCollapseItems}
        // select={this.sortFunction.bind(this)}
      >
        SORT
      </DropDownButtonComponent>
    );
  }
  constructor(props: IProps) {
    super(props);
    this.applyFilter = this.applyFilter.bind(this);
    this.checkboxObj = new CheckBoxComponent(props);
    this.mulObj = new MultiSelectComponent(props);
    this.contextMenuObj = new ContextMenuComponent({});
    this.state = {
      largeMode: true,
      queryParameter: [],
      endDate: new Date(),
      startDate: new Date(),
      allButton: true,
      currentDate: new Date(),
      schedulerAssignmentData: [],
      schedulerData: [],
      rosterData: [],
      current_query: '',
      shiftValues: [],
      isShiftHide: true,
      enableProfileImg: false,
      showDialog: false,
      showCapacityDialog: false,
    };
    this.objSce = new ScheduleComponent(props);
    Scheduler.AllFilterDAta = this.generateInitialFilter();
  }
  applyFilter() {
    this.props.setDefaultTeams(this.defaultTeamList);
  }
  getAssignImage(value: any) {
    var name = defaultImage;
    return name;
  }
  resourceHeaderTemplate(props: any) {
    let tradeName = '';
    let teamName = '';
    let aliasSurnameFirstName =
      props.resourceData.last_name + ' ' + props.resourceData.first_name;
    if (props.resourceData.trades) {
      tradeName = `[${props.resourceData.trades}]`;
    }
    if (props.resourceData.teams) {
      teamName = `[${props.resourceData.teams}]`;
    }
    return (
      <TooltipComponent
        content={props.resourceData.alias_name}
        position={'LeftTop'}
        tabIndex={0}
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: this.context.isDarkMode ? '#15202B' : '#EAEAEA',
        }}
      >
        <div
          style={{
            display: this.state.enableProfileImg ? undefined : 'none',
          }}
        >
          <img className='assign-image' src={this.getAssignImage(props)}></img>
        </div>
        <div style={{ color: '#22d3ee' }}>
          <div className='assign-name'>
            {aliasSurnameFirstName?.length >= 11
              ? aliasSurnameFirstName?.substring(0, 11) + '...'
              : aliasSurnameFirstName}
          </div>
          <label
            className='assign-trades'
            style={{ display: 'flex', fontSize: '10px' }}
          >
            {teamName + tradeName}
          </label>
        </div>
      </TooltipComponent>
    );
  }
  popupOpen(args: any) {
    if (args.type !== 'EventContainer') {
      args.cancel = true;
    }
  }
  lastDayCalculate(y: any, m: any) {
    return new Date(y, m + 1, 0).getDate();
  }
  componentDidMount() {
    // var localStorageDefaultTeams = localStorage.getItem('defaultTeams') ??"";
    // this.defaultTeamList = stringToArray(localStorageDefaultTeams)
    this.isMountForData = true;
    $('.hideSUp').hide();
    $('.hideUp').hide();
    $('.filter-page').css({
      height: '300px',
    });
    $('.settings-page').css({
      height: '300px',
    });
    loadingShow(true);
    // this.getSchedulerAssignmentList();
    this.getRosterData();
    setTimeout(() => {
      loadingShow(false);
    }, 8000);
    setTimeout(() => {
      this.buildQuery(false);
    }, 100);
  }
  getRosterData() {
    GetRosters()
      .then((res) => {
        loadingShow(false);
        var model = res.data.map((data: any) => {
          return {
            ELEMENT_ALIAS: data.elementAliasValue,
            COLOR: data.rostercolor,
          };
        });
        const data = this.getElementAliasfiltering(model);
        this.setState({ rosterData: data });
      })
      .catch((err) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  getElementAliasfiltering(model: any) {
    const filteredArr = model.reduce((acc: any, current: any) => {
      const x = acc.find(
        (item: any) => item.ELEMENT_ALIAS === current.ELEMENT_ALIAS
      );
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return filteredArr;
  }
  renderColor = (result: any) => {
    return;
  };
  CapacityToTime(capacity: any) {
    if (capacity === undefined) {
      return '00:00';
    } else {
      var sec_num = parseInt(capacity); // don't forget the second param
      var hours = (sec_num / 60)?.toString().split('.')[0];
      var minutes = sec_num - parseInt(hours) * 60;

      var resultHour = hours?.toString();
      var resultMinutes = minutes?.toString();
      if (parseInt(hours) < 10 && parseInt(hours) >= 0) {
        resultHour = '0' + hours;
      }
      if (parseInt(hours) < 0 && parseInt(hours) > -10) {
        resultHour = '-0' + -1 * parseInt(hours);
      }
      if (minutes < 10 && minutes >= 0) {
        resultMinutes = '0' + minutes;
      }
      if (minutes < 0 && minutes > -10) {
        resultMinutes = '0' + -1 * minutes;
      }
      return resultHour + ':' + resultMinutes;
    }
  }
  generateInitialFilter = () => {
    let date = new Date();
    var startDate = date.getMonth() + 1 + '/' + 1 + '/' + date.getFullYear();
    var endDate =
      date.getMonth() +
      1 +
      '/' +
      this.lastDayCalculate(date.getFullYear(), date.getMonth()) +
      '/' +
      date.getFullYear();
    var modelElementAlias = this.state.rosterData.map((res: any) => {
      return res.ELEMENT_ALIAS;
    });
    var result: any = modelElementAlias;
    var elementAliasArray = result.filter(function (item: any, pos: any) {
      return result.indexOf(item) === pos;
    });
    var alias = '';
    elementAliasArray.map((sh: any) => {
      alias += "'" + sh + "',";
    });
    alias = alias.replace(/.$/, '');
    const asignments: any = [];
    startDate += ' ' + `${Number(this.getTZDiff()) / (60000 * 60)}:00:00`;
    endDate += ' ' + `${Number(this.getTZDiff()) / (60000 * 60)}:00:00`;
    return `'${startDate}'$'${endDate}'$${asignments}$${alias}$'${
      Number(this.getTZDiff()) / (60000 * 60)
    }:00:00'`;
  };
  navigating(args: any) {
    if (args?.action === 'view') {
      this.viewIndex = args.viewIndex;
    }
    if (args?.action === 'date' && this.viewIndex === 0) {
      let startDate = args?.currentDate;
      startDate = startDate.setDate(1);
      this.DateRangeValue[0] = startDate;

      let date = new Date(args?.currentDate);
      date.setMonth(date.getMonth() + 1);
      date.setDate(0);
      this.DateRangeValue[1] = date;
      this.buildQuery(false);
    }
    if (args.requestType === 'dateNavigate') {
    }
  }
  changeNavigateDate() {
    this.setState({ currentDate: new Date(this.DateRangeValue[0]) });
  }

  onActionBegin(args: any, i: any) {
    if (args.requestType === 'toolbarItemRendering') {
      let exportItem = {
        align: 'Right',
        showTextOn: 'Both',
        prefixIcon: 'e-icon-schedule-excel-export',
        text: 'Excel Export',
        cssClass: 'e-excel-export',
        click: this.onExportClick.bind(this),
      };
      let RefreshItem = {
        align: 'Right',
        showTextOn: 'Both',
        prefixIcon: 'e-icon-schedule-excel-export',
        text: 'Refresh',
        cssClass: 'e-excel-export',
        click: this.refreshSchec,
      };
      let ChangeMode = {
        align: 'Right',
        showTextOn: 'Both',
        prefixIcon: 'e-icon-schedule-excel-export',
        text: 'Change Mode',
        cssClass: 'e-excel-export',
        click: this.changeMode,
      };
      let Sort = {
        align: 'Right',
        showTextOn: 'Both',
        text: 'Compact View',
        cssClass: 'e-excel-export',
        // template: this.sortDropDown.bind(this),
        click: this.sortbyLastNameFunction,
      };

      args.items.push(exportItem);
      args.items.push(RefreshItem);
      args.items.push(ChangeMode);
      args.items.push(Sort);
    }
  }

  onExportClick() {
    this.objSce.exportToExcel();
  }
  componentDidUpdate(prevProps: any) {
    // if (this.context.isDataChangeSchedule) {
    //   this.isMountForData = true;
    //   this.buildQuery(false);
    //   this.context.setDataChange(false);
    // }
    if (prevProps.defaultAssignments !== this.props.defaultAssignments) {
      this.buildQuery(false);
    }
  }
  filterHightUp() {
    $('.filter-page').css({
      height: '300px',
    });
    $('.hideUp').hide();
    $('.hideDown').show();
  }
  settingsHightUp() {
    $('.settings-page').css({
      height: '300px',
    });
    $('.hideSUp').hide();
    $('.hideSDown').show();
  }
  filterHightDown() {
    $('.hideUp').show();
    $('.hideDown').hide();
    $('.filter-page').css({
      height: '100px',
    });
  }
  settingsHightDown() {
    $('.hideSUp').show();
    $('.hideSDown').hide();
    $('.settings-page').css({
      height: '100px',
    });
  }
  loadingShow = () => {
    this.objSce.eventSettings = {
      dataSource: this.data.filter((e: any) => {
        const theStarTime = new Date(
          this.state.startDate as unknown as Date
        ).toLocaleDateString();
        const theEndTime = new Date(
          this.state.endDate as unknown as Date
        ).toLocaleDateString();
        const start = new Date(e.starttime).toLocaleDateString();
        const end = new Date(e.endtime).toLocaleDateString();
        const condStart =
          this.state.startDate == null ? false : theStarTime == start;
        const condEnd = this.state.endDate == null ? false : theEndTime == end;
        return condStart || condEnd;
      }),
      enableMaxHeight: true,
      enableIndicator: true,
    };
    const theCurrent =
      this.state.startDate !== null ? this.state.startDate : this.state.endDate;
    this.setState({ allButton: false, currentDate: theCurrent as Date });
  };
  allData = () => {
    this.objSce.eventSettings = { dataSource: this.data };
    this.setState({
      startDate: null,
      endDate: null,
      allButton: true,
      currentDate: new Date(),
    });
  };
  callback = (e: any) => {
    if (this.state.queryParameter.length === 0) {
      return e;
    }
    const cond1 = this.state.queryParameter.includes(e.Teams);
    return cond1;
  };
  public passToSche(val: string) {}
  setStartDate(e: any) {
    this.setState({ startDate: e.value });
  }
  setEndDate(e: any) {
    this.setState({ endDate: e.value });
  }
  getTZDiff() {
    const serverOffsetMinutes = this.props.server_gmt * 60;
    return serverOffsetMinutes * 60000;
  }
  FilterFonkScheduler() {
    loadingShow(true);
    // this.changeNavigateDate();
    this.props.setfilterConfirmation(true);
    this.buildQuery(true);
  }
  getCapacity(query: string) {
    GetSchedulerList(query).then(async (resCapacity) => {
      const gmt = this.props.server_gmt;
      const sign = gmt >= 0 ? '+' : '-';
      const absHours = Math.abs(gmt).toString().padStart(2, '0');
      const tzSuffix = `${sign}${absHours}:00`;
      const toUTCDate = (dateValue: any): Date => {
        if (dateValue instanceof Date) return dateValue;
        if (typeof dateValue === 'string') {
          const hasTimezone = /Z|[+-]\d{2}:\d{2}$/.test(dateValue);
          if (!hasTimezone) {
            return new Date(dateValue + tzSuffix);
          }
        }
        return new Date(dateValue);
      };

      var modelCapacity = resCapacity.data.capacity?.map((result: any) => {
        return {
          ...result,
          id: parseInt(result.assignmentid),
          assignment_id: result.assignmentid,
          EndTime: toUTCDate(result.endtime),
          Id: parseInt(result.capacity_id),
          StartTime: toUTCDate(result.starttime),
          Subject: this.renderColor(result),
        };
      });
      this.globalSchedularData = modelCapacity;
      loadingShow(false);
      const allTrades = await getTrades().then((res) => res.data);
      var tempList = [];
      if (this.props.defaultTeams?.length > 0) {
        this.props.defaultAssignments.map(
          (eachAssignmentid: number, index: number) => {
            this.globalSchedularData.map(
              (eachData: { assignment_id: number }) => {
                if (
                  eachData.assignment_id &&
                  eachData.assignment_id === eachAssignmentid
                ) {
                  tempList.push(eachData);
                }
              }
            );
          }
        );
      } else {
        tempList = modelCapacity;
      }
      resCapacity.data.assignment.map(
        (eachAssignmentObject: { trade_id: number | null; trades: string }) => {
          var matched = false;
          allTrades.map((eachtrade: { trade_code: string }) => {
            if (eachAssignmentObject.trades == eachtrade.trade_code) {
              matched = true;
            }
          });
          if (!matched) {
            eachAssignmentObject.trades = '';
          }
        }
      );
      var tempAssignmentList = [];
      if (this.props.defaultTeams?.length > 0) {
        this.props.defaultAssignments.map(
          (eachAssignmentid: number, index: number) => {
            resCapacity.data.assignment.map(
              (eachData: { assignment_id: number }) => {
                if (
                  eachData.assignment_id &&
                  eachData.assignment_id === eachAssignmentid
                ) {
                  tempAssignmentList.push(eachData);
                }
              }
            );
          }
        );
      } else {
        tempAssignmentList = resCapacity.data.assignment;
      }

      const updatedList = tempList.map(item => {
        return {
          ...item,
          starttime: toUTCDate(item.starttime),
          endtime: toUTCDate(item.endtime),
          StartTime: toUTCDate(item.starttime),
          EndTime: toUTCDate(item.endtime),
        };
      });

      const normalizedAssignments = tempAssignmentList.map((a: any) => ({
        ...a,
        trades: a.trades
          ? (typeof a.trades === 'string'
              ? [{ trade_code: a.trades, trade_id: a.trade_id ?? 0 }]
              : a.trades)
          : [],
        teams: a.teams
          ? (typeof a.teams === 'string'
              ? [{ team_code: a.teams, team_id: a.team_id ?? 0 }]
              : a.teams)
          : [],
      }));

      this.setState({
        schedulerData: updatedList,
        schedulerAssignmentData: normalizedAssignments,
      });
    });
  }
  onChangeShiftElement(args: any) {
    Scheduler.StoreShift = [];
    Scheduler.StoreShift.push(...args.value);
    this.setState({ shiftValues: args.value });
  }
  onChangeTimezone(args: any) {
    this.objSce.timezone = args.value;
  }
  clearFilter() {
    $('#daterangepickerFilter').val('');
    this.mulObj.value = null;
    Scheduler.AllFilterDAta = this.generateInitialFilter();
    this.setState({ shiftValues: [] });
    this.DateRangeValue = [];
    this.buildQuery(true);
  }
  private itemTemplate(data: any): JSX.Element {
    return (
      <span>
        <span
          id='multiselectColor'
          style={{ backgroundColor: data.COLOR }}
        ></span>
        <span>{data.ELEMENT_ALIAS}</span>
      </span>
    );
  }
  componentWillUnmount(): void {
    this.isMountForData = false;
  }
  buildQuery(isFilterSide: boolean) {
    this.current_query = this.state.current_query.trimEnd();
    this.current_query = this.current_query.replace(this.theQueryDate, '');
    this.current_query = this.current_query.replace(this.theQueryShift, '');
    this.current_query = this.current_query.replace(this.theQueryTeams, '');
    this.current_query = this.current_query.replace(this.theQueryTrades, '');
    this.current_query = this.current_query.replace(
      this.theQueryAssignmentsSpecial,
      ''
    );
    this.current_query = this.current_query.replace(
      this.theQueryAssignments,
      ''
    );
    var theDate = this.DateRangeValue;
    var theShifts = this.state.shiftValues;
    if (theShifts.length > 0) {
      if (this.current_query !== '') {
        this.theQueryShift = this.addToQuery(
          'shift',
          'in',
          'andWhere',
          theShifts?.toString(),
          this.theQueryShift
        );
      } else {
        this.theQueryShift = this.addToQuery(
          'shift',
          'in',
          'where',
          theShifts?.toString(),
          this.theQueryShift
        );
      }
    }
    if (this.props.storeTrades.length > 0 && isFilterSide) {
      if (this.current_query !== '') {
        this.theQueryTrades = this.addToQuery(
          'trade_code',
          'in',
          'andWhere',
          this.props.storeTrades?.toString(),
          this.theQueryTrades
        );
      } else {
        this.theQueryTrades = this.addToQuery(
          'trade_code',
          'in',
          'where',
          this.props.storeTrades?.toString(),
          this.theQueryTrades
        );
      }
    }
    if (theDate !== null && theDate) {
      if (theDate.length > 0) {
        var start_date = moment(theDate[0]).format('yyyy-MM-DD');
        var end_date = moment(theDate[1]).add(1, 'day').format('yyyy-MM-DD');
        if (this.current_query !== '') {
          this.theQueryDate = this.addToQuery(
            'starttime',
            '>=',
            'andWhere',
            start_date,
            this.theQueryDate
          );
          this.theQueryDate += this.addToQuery(
            'endtime',
            '<=',
            'andWhere',
            end_date,
            this.theQueryDate
          );
        } else {
          this.theQueryDate = this.addToQuery(
            'starttime',
            '>=',
            'where',
            start_date,
            this.theQueryDate
          );
          this.theQueryDate += this.addToQuery(
            'endtime',
            '<=',
            'andWhere',
            end_date,
            this.theQueryDate
          );
        }
      }
    }

    ///////////////////////////ASSIGNMENTS///////////////////////////
    if (
      (this.props.storeAssign.length > 0 ||
        this.props.storeTeam.length > 0 ||
        this.props.storeTradeAssignmentIds.length > 0) &&
      isFilterSide
    ) {
      if (this.current_query !== '') {
        this.theQueryAssignments = this.addToQuery(
          'assignmentid',
          'in',
          'andWhere',
          `${[
            ...this.props.storeAssign,
            ...this.props.storeTeam,
            ...this.props.storeTradeAssignmentIds,
          ]?.toString()}`,
          this.theQueryAssignments
        );
      } else {
        this.theQueryAssignments = this.addToQuery(
          'assignmentid',
          'in',
          'where',
          `${[
            ...this.props.storeAssign,
            ...this.props.storeTeam,
            ...this.props.storeTradeAssignmentIds,
          ]?.toString()}`,
          this.theQueryAssignments
        );
      }
      this.theQueryAssignmentsSpecial = `$${[
        ...this.props.storeAssign,
        ...this.props.storeTeam,
        ...this.props.storeTradeAssignmentIds,
      ]?.toString()}`;
      this.current_query += this.theQueryAssignmentsSpecial;
    }
    // this.setState({
    //   current_query: this.current_query + ' ',
    // });
    Scheduler.AllFilterDAta = this.current_query;
    if (isFilterSide) {
      this.context.setDataChangeKpiTeam(true);
      this.context.setDataChangeKpiTrade(true);
      this.context.setDataChangeKpiTradePerson(true);
      this.context.setDataChangeKpiShift(true);
      this.context.setChangeTabPane(true);
    }
    this.getCapacity(this.current_query);
  }
  addToQuery = (
    field: string,
    c: string,
    type: string,
    v: string,
    current_query: string
  ) => {
    current_query = JSON.stringify({
      f: field,
      c: c,
      t: type,
      v: v,
    });
    current_query += '?';
    this.current_query += current_query;
    return current_query;
  };
  switchOnChange = (e: any) => {
    this.setState({ isShiftHide: e.target.checked });
    this.buildQuery(false);
  };
  refreshSchec = () => {
    loadingShow(true, 'Refreshing');
    //this.props.setRefreshAssignmentComponent(true);
    // this.props.setRefreshTeamComponent(true);
    // this.props.setRefreshTradeComponent(true);
    this.getCapacity(this.current_query);
    loadingShow(false);
  };
  changeMode = () => {
    this.setState({ largeMode: !this.state.largeMode });
    this.props.changelargeMode();
  };
  switchOnChangeProfile = (e: any) => {
    this.setState({ enableProfileImg: e.target.checked });
  };

  eventTemplate = (result: any) => {
    let currentColor = result.shift_color;
    let currentContent;
    if (result.shift === 'NOTE') {
      currentContent = (
        <>
          <GoPencil size={25} color='white' />{' '}
          <span style={{ marginLeft: '5px' }}>{result.explanation}</span>
        </>
      );
    } else {
      currentContent = this.state.isShiftHide ? result.shift : null;
    }
    if (result.shift_color === null && !currentColor) {
      currentColor = 'red';
    }
    let theStyle: any = {
      backgroundColor: currentColor,
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
      justifySelf: 'center',
    };
    return (
      <div
        style={
          result.shift === 'NOTE'
            ? {
                ...theStyle,
              }
            : { ...theStyle }
        }
      >
        {currentContent}
      </div>
    );
  };
  eventRendered = (result: any) => {
    result.element.style.backgroundColor = result.data.shift_color;
    result.element.style.padding = '3px';
    result.element.style.borderRadius = '8px';
    result.element.style.display = 'flex';

    const startDate = moment.utc(result.data.starttime).utcOffset(this.props.server_gmt).format('DD/MM/yyyy HH:mm');
    const endDate = moment.utc(result.data.endtime).utcOffset(this.props.server_gmt).format('DD/MM/yyyy HH:mm');
    var calculateCapacity = this.CapacityToTime(result.data.capacityhours);
    if (result.data.shift_color === null) {
      result.data.shift_color = 'red';
    }
    let title = '';
    if (result.data.shift === 'NOTE') {
      result.element.style.backgroundColor = 'result.data.shift_color';
      title =
        // 'Capacity : ' +
        // calculateCapacity +
        // '\n\n' +
        startDate +
        ' - ' +
        endDate +
        '\n\nNote : ' +
        result.data.comments +
        '\n\nType : ' +
        result.data.explanation;
    } else {
      title =
        'Capacity : ' +
        calculateCapacity +
        '\n\n' +
        startDate +
        ' - ' +
        endDate +
        '\n\nShift : ' +
        result.data.shift;
    }
    result.element.title = title;
  };
  removeTimeSlost() {
    let theData = $('.e-schedule-table tbody tr.e-header-row');
    if (theData) {
      if (theData.length > 0) {
        theData[1].style.display = 'none';
      }
    }
  }
  onSettings = () => {
    if (this.isPanelOpened) {
      $('.settings-page').css('width', '0px');
      $('.settings-page').css('height', '120px');
      this.isPanelOpened = false;
    } else {
      $('.settings-page').css('width', '100%');
      $('.settings-page').css('height', '200px');
      this.isPanelOpened = true;
      this.filterHightDown();
    }
  };
  private contextMenuOpen = (args: any) => {
    let newEventElement = document.querySelector('.e-new-event');
    // if (newEventElement) {
    //     remove(newEventElement);
    //     removeClass([document.querySelector('.e-selected-cell')], 'e-selected-cell');
    // }
    this.objSce.closeQuickInfoPopup();
    let targetElement = args.event.target;
    if (closest(targetElement, '.e-contextmenu')) {
      return;
    }
    this.selectedTarget = closest(
      targetElement,
      '.e-appointment,.e-work-cells,.e-vertical-view .e-date-header-wrap .e-all-day-cells,.e-vertical-view .e-date-header-wrap .e-header-cells'
    );
    if (isNullOrUndefined(this.selectedTarget)) {
      args.cancel = true;
      return;
    }
    if (this.selectedTarget.classList.contains('e-appointment')) {
      let eventObj = this.objSce.getEventDetails(this.selectedTarget);
      if (eventObj.RecurrenceRule) {
        this.contextMenuObj.showItems(['DeleteRecurrenceEvent'], true);
        this.contextMenuObj.hideItems(
          [
            'Add',
            'AddRecurrence',
            'Today',
            'Save',
            'Delete',
            'EditRecurrenceEvent',
            'EditOccurrence',
            'EditSeries',
          ],
          true
        );
      } else {
        this.contextMenuObj.showItems(['Save', 'Delete'], true);
        this.contextMenuObj.hideItems(
          [
            'Add',
            'AddRecurrence',
            'Today',
            'Save',
            'DeleteRecurrenceEvent',
            'EditRecurrenceEvent',
            'EditOccurrence',
            'EditSeries',
          ],
          true
        );
      }
      return;
    } else if (
      (this.selectedTarget.classList.contains('e-work-cells') ||
        this.selectedTarget.classList.contains('e-all-day-cells')) &&
      !this.selectedTarget.classList.contains('e-selected-cell')
    ) {
      removeClass(
        [].slice.call(this.objSce.element.querySelectorAll('.e-selected-cell')),
        'e-selected-cell'
      );
      this.selectedTarget.setAttribute('aria-selected', 'true');
      this.selectedTarget.classList.add('e-selected-cell');
    }
    this.contextMenuObj.hideItems(
      [
        'Save',
        'Delete',
        'EditRecurrenceEvent',
        'DeleteRecurrenceEvent',
        'AddRecurrence',
        'Today',
      ],
      true
    );
    this.contextMenuObj.showItems(['Add'], true);
  };
  private contextMenuSelect = (args: any) => {
    let selectedMenuItem = args.item.id;
    let eventObj: any = {};
    if (
      this.selectedTarget &&
      this.selectedTarget.classList.contains('e-appointment')
    ) {
      eventObj = this.objSce.getEventDetails(this.selectedTarget) as any;
    }

    let selectedCells = this.objSce.getSelectedElements();
    if (selectedCells.length > 0) {
      let activeCellsData: any = this.objSce.getCellDetails(
        selectedCells.length > 0 ? selectedCells : this.selectedTarget
      );

      let thePerson =
        this.state.schedulerAssignmentData[activeCellsData.groupIndex];

      this.selectedName = thePerson.alias_name;
      this.activeCellsData = activeCellsData;
      this.thePerson = thePerson;
    }
    switch (selectedMenuItem) {
      case 'Add':
        this.setState({ showDialog: true });
        break;
      case 'Create':
        this.setState({ showCapacityDialog: true });
        break;
      case 'AddRecurrence':
        break;
      case 'Save':
      case 'Delete':
        this.objSce.deleteEvent(eventObj);
        DeleteCapacityWithIDRequest({ capacity_id: eventObj.capacity_id });
        break;
    }
  };
  getTimeZoneDifference = () => {
    const serverOffsetMinutes = this.props.server_gmt * 60;
    return serverOffsetMinutes * 60000;
  };
  private onNoteSave = async () => {
    if (this.noteTextbox.value === null || this.typeDropDown.value === null) {
      Message.error('Type or note field cannot be empty');
      loadingShow(false);
      return false;
    }
    loadingShow(true, 'Proccesing');
    const theObj = {
      app: 'UWORK',
      organization_id: all_information.company_id.toString(),
      assignmentid: this.thePerson.assignment_id,
      starttime: this.activeCellsData.startTime,
      endtime: this.activeCellsData.endTime,
      created_by: all_information.user_id,
      creation_date: new Date(),
      shift: 'NOTE',
      comments: this.noteTextbox.value,
      explanation: this.typeDropDown.value,
      shift_color: this.selected_note_color,
      note_id: this.selected_note_id,
    };
    let objCollection: any = {};
    if (this.isNoteModeCapacitySwitchChecked) {
      objCollection = {
        CapacityCollection: [theObj],
        state_of_proc: 'capacity',
        diff_to_TimeZone: `${
          Number(this.getTimeZoneDifference()) / (60000 * 60)
        }:00:00`,
        end_date: this.activeCellsData.endTime,
        start_date: this.activeCellsData.startTime,
      };
    } else {
      objCollection = {
        CapacityCollection: [theObj],
      };
    }
    CreateNoteCapacity(objCollection, (res: any) => {
      loadingShow(false);
      this.objSce.addEvent({
        ...res,
        assignmentid: this.thePerson.assignment_id,
        id: this.thePerson.assignment_id,
        Id: res.capacity_id,
        starttime: this.activeCellsData.startTime,
        endtime: this.activeCellsData.endTime,
        EndTime: this.activeCellsData.endTime,
        StartTime: this.activeCellsData.startTime,
        assignment_id: this.thePerson.assignment_id,
      });
      this.buildQuery(false);
    });
    this.setState({ showDialog: false });
  };
  public instance = new Internationalization();

  getDateRange = (startDate: any, endDate: any) => {
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
    }).format(startDate);
  };
  dateRangeTemplate = (props: any) => {
    return <div>{this.getDateRange(props.startDate, props.endDate)}</div>;
  };
  render() {
    return (
      <>
        <ScheduleComponent
          cssClass='block-events'
          id='scheduleComponent'
          width='100%'
          height={
            this.state.largeMode ? 'calc(-90px + 99vh)' : 'calc(-90px + 76vh)'
          }
          ref={(sc) => (this.objSce = sc as ScheduleComponent)}
          selectedDate={this.state.currentDate}
          currentView='TimelineMonth'
          resourceHeaderTemplate={this.resourceHeaderTemplate.bind(this)}
          resources={[]}
          popupOpen={this.popupOpen.bind(this)}
          eventSettings={{ dataSource: this.state.schedulerData }}
          timeScale={{ interval: 1440 }}
          dataBound={() => {
            this.removeTimeSlost();
          }}
          timezone={this.props.server_gmt >= 0
            ? `Etc/GMT-${this.props.server_gmt}`
            : `Etc/GMT+${Math.abs(this.props.server_gmt)}`
          }
          group={{
            enableCompactView: false,
            resources: ['Assignment'],
          }}
          actionComplete={(args: any) => {
            this.removeTimeSlost();
          }}
          rowAutoHeight={true}
          allowResizing={true}
          actionBegin={this.onActionBegin.bind(this)}
          navigating={this.navigating.bind(this)}
          renderCell={(args) => {
            return <div>{args.element}</div>;
          }}
          eventRendered={this.eventRendered.bind(this)}
          //dateRangeTemplate={this.dateRangeTemplate}
        >
          <ResourcesDirective>
            <ResourceDirective
              field='assignment_id'
              title='Assignments'
              name='Assignment'
              allowMultiple={true}
              dataSource={this.state.schedulerAssignmentData}
              textField='alias_name'
              idField='assignment_id'
            ></ResourceDirective>
          </ResourcesDirective>

          <ViewsDirective>
            <ButtonComponent
              content='Change Mode'
              onClick={() => {
                this.changeMode();
              }}
            ></ButtonComponent>
            <ButtonComponent
              content='Refresh Trade Planer'
              onClick={() => {
                this.refreshSchec();
              }}
            ></ButtonComponent>
            <ViewDirective
              option='TimelineMonth'
              displayName='1 Month'
              interval={1}
              eventTemplate={this.eventTemplate.bind(this)}
              isSelected={true}
            />
            <ViewDirective
              option='TimelineWeek'
              displayName='1 Week'
              interval={1}
              eventTemplate={this.eventTemplate.bind(this)}
            />
            <ViewDirective
              option='TimelineWeek'
              displayName='2 Weeks'
              interval={2}
              eventTemplate={this.eventTemplate.bind(this)}
            />
            <ViewDirective
              option='TimelineMonth'
              displayName='3 Months'
              interval={3}
              eventTemplate={this.eventTemplate.bind(this)}
            />
          </ViewsDirective>

          <Inject
            services={[
              Day,
              Week,
              WorkWeek,
              Month,
              TimelineViews,
              Resize,
              DragAndDrop,
              TimelineMonth,
              Resize,
              ExcelExport,
            ]}
          />
        </ScheduleComponent>

        <ContextMenuComponent
          id='overviewContextMenu'
          cssClass='schedule-context-menu'
          ref={(ref: ContextMenuComponent) => (this.contextMenuObj = ref)}
          target='.e-schedule'
          items={this.contextMenuItems}
          beforeOpen={this.contextMenuOpen}
          select={this.contextMenuSelect}
        />

        {this.state.showDialog ? (
          <GlobalDialog
            showDialog={this.state.showDialog}
            setShowDialog={(val: boolean) => this.setState({ showDialog: val })}
            header={`Add Note`}
            width={'25%'}
            height={'31%'}
            hideDoneButton={true}
            buttons={[
              {
                buttonModel: { content: 'Cancel' },
                click: () => this.setState({ showDialog: false }),
              },
              {
                buttonModel: { content: 'Save', isPrimary: true },
                click: this.onNoteSave.bind(this),
              },
            ]}
          >
            <div>
              <TPlannerNoteContent
                hideRange={true}
                isVisible={true}
                texboxRef={(tb: any) => (this.noteTextbox = tb)}
                selectedName={this.selectedName}
                dropDownRef={(dd: DropDownListComponent) =>
                  (this.typeDropDown = dd)
                }
                dateRangePickerOnChange={(args) => {
                  this.NoteModeRangeDate = args.value;
                }}
                onCapacitySwitchChange={(args: any) => {
                  this.isNoteModeCapacitySwitchChecked = args?.checked;
                  // setIsCapacitySwitchChecked(args?.checked);
                }}
                onChange={(args: any) => {
                  this.selected_note_color = args.target.itemData.color;
                  this.selected_note_id = args.target.itemData.id;
                }}
              />
            </div>
          </GlobalDialog>
        ) : null}

        {this.state.showCapacityDialog ? (
          <GenerateCapacity
            assignments={[this.thePerson]}
            isNoteMode={false}
            hideDialog={this.state.showCapacityDialog}
            setHideDialogCapacity={(val) =>
              this.setState({ showCapacityDialog: val })
            }
            rangeDefined={this.activeCellsData}
          />
        ) : null}
        <div className='settings-page'>
          <div className='filter-child'>
            <div className='filter-icon'>
              <div className='first-icon'>
                <IoIosSettings size={30} onClick={this.onSettings.bind(this)} />
                Settings
              </div>
              <div className='second-icon'>
                <div className='hideSUp'>
                  <IoIosArrowUp
                    onClick={this.settingsHightUp.bind(this)}
                    size={20}
                  />
                </div>
                <div className='hideSDown'>
                  <IoIosArrowDown
                    onClick={this.settingsHightDown.bind(this)}
                    size={20}
                  />
                </div>
              </div>
            </div>
            <div className='filter-content'>
              <div className='row mb-3'>
                <div className='col-md-12'>
                  <div className='col-md-6'>Shift Name</div>
                  <div className='col-md-6'>
                    <SwitchComponent
                      style={{ marginLeft: '10px' }}
                      onChange={this.switchOnChange.bind(this)}
                      checked={true}
                    />
                  </div>
                </div>
              </div>
              <div className='row mb-3'>
                <div className='col-md-12'>
                  <div className='col-md-6'>Profile Image</div>
                  <div className='col-md-6'>
                    <SwitchComponent
                      style={{ marginLeft: '10px' }}
                      onChange={this.switchOnChangeProfile.bind(this)}
                      checked={this.state.enableProfileImg}
                    />
                  </div>
                </div>
              </div>
              <div>
                <GlobalMultiSelection
                  refDD={(scope: MultiSelectC) => {
                    this.defaultTeam = scope;
                  }}
                  field={{ value: 'team_id', text: 'team_code' }}
                  id='deafaultTeams'
                  url='team'
                  placeHolder='Select Default Teams'
                  // value={this.}
                  onChange={(e: any) => {
                    this.defaultTeamList = e.value;
                    localStorage.setItem('defaultTeams', this.defaultTeamList);
                  }}
                  enablePersistence={true}
                />
              </div>
              <div
                className='btn-filter w-100'
                style={{ marginTop: '10px' }}
                onClick={this.applyFilter}
              >
                <span>Set Default Teams</span>
              </div>
            </div>
          </div>
        </div>
        <div className='filter-page'>
          <div className='filter-child'>
            <div className='filter-icon'>
              <div className='first-icon'>
                <FcFilledFilter size={20} />
                Filter
              </div>
              <div className='second-icon'>
                <div className='hideUp'>
                  <IoIosArrowUp
                    onClick={this.filterHightUp.bind(this)}
                    size={20}
                  />
                </div>
                <div className='hideDown'>
                  <IoIosArrowDown
                    onClick={this.filterHightDown.bind(this)}
                    size={20}
                  />
                </div>
              </div>
            </div>
            <div className='filter-content'>
              <div className='filter-body'>
                <div className='row mb-3' style={{ flexDirection: 'row' }}>
                  <div className='col-md-12'>
                    <DateRangePickerComponent
                      cssClass='customCSS '
                      id='daterangepickerFilter'
                      format={'dd/MM/yyyy'}
                      placeholder='Select a range'
                      value={this.DateRangeValue}
                      delayUpdate={true}
                      onChange={(el: any) => {
                        localStorage.setItem(
                          'TradePlannerDate',
                          JSON.stringify(el.value)
                        );
                        this.DateRangeValue = el.value;
                      }}
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-12'>
                    <div className='roster-grafik'>
                      <MultiSelectComponent
                        id='shiftElementFilter'
                        ref={(scope) => {
                          (this.mulObj as any) = scope;
                        }}
                        dataSource={this.state.rosterData}
                        fields={this.checkFields}
                        placeholder='Select a element alias'
                        mode='CheckBox'
                        value={this.state.shiftValues}
                        showSelectAll={true}
                        enabled={true}
                        showClearButton={true}
                        showDropDownIcon={true}
                        filterBarPlaceholder='Search a shift'
                        onChange={this.onChangeShiftElement.bind(this)}
                        itemTemplate={
                          (this.itemTemplate = this.itemTemplate.bind(this))
                        }
                      >
                        <Inject services={[CheckBoxSelection]} />
                      </MultiSelectComponent>
                    </div>
                  </div>
                </div>
              </div>
              <div className='filter-footer'>
                <div
                  className='btn-filter w-100'
                  onClick={this.FilterFonkScheduler.bind(this)}
                >
                  <span>
                    <RiFilterFill size={15} color='#f7b731' />
                  </span>
                  <span>Apply filter</span>
                </div>
                <div
                  className='btn-clear-filter  w-100'
                  onClick={this.clearFilter.bind(this)}
                >
                  <span>
                    <RiFilterOffFill size={15} color='red' />
                  </span>
                  <span>Clear filter</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state: RootState) => ({
  defaultTeams: state.search.defaultTeams,
  defaultAssignments: state.search.defaultAssignments,
  largeMode: state.search.largeMode,
  storeTeam: state.search.storeTeam,
  storeTrades: state.search.storeTrades,
  storeAssign: state.search.storeAssign,
  storeTradeAssignmentIds: state.search.storeTradeAssignmentIds,
  filterConfirmation: state.search.filterConfirmation,
  weekStartDay: state.search.weekStartDay,
  server_gmt: state.search.server_gmt
});

const mapDispatchToProps = (dispatch: any) => ({
  changelargeMode: () => dispatch(changelargeMode()),
  setfilterConfirmation: (value: boolean) =>
    dispatch(setfilterConfirmation(value)),
  setDefaultTeams: (value: []) => dispatch(setDefaultTeams(value)),
  setRefreshAssignmentComponent: (value: boolean) =>
    dispatch(setRefreshAssignmentComponent(value)),
  setRefreshTeamComponent: (value: boolean) =>
    dispatch(setRefreshTeamComponent(value)),
  setRefreshTradeComponent: (value: boolean) =>
    dispatch(setRefreshTradeComponent(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Scheduler);
